export enum TransaktionsObjektType {
  Liegenschaft = '0',
  Baurecht = '1',
}
